import { RootState } from "../../../app/store";

export const selectAccountIsLoading = (state: RootState) =>
  state.account.isLoading;
